import { Button, Checkbox, NumberInput, Progress, Textarea } from '@mantine/core';
import { IconChecks } from '@tabler/icons-react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './ChecklistSubmissionForm.module.scss';
import { Props } from './ChecklistSubmissionForm.types';

const ChecklistSubmissionForm = ({
  onCancel,
  form,
  onSubmit,
  submitButtonLabel,
  checklist,
}: Props) => {
  const { t } = useTranslation();

  const totalItems = form.values.items.length;
  const checkedItems = form.values.items.filter(item => item.isChecked).length;
  const progress = totalItems > 0 ? (checkedItems / totalItems) * 100 : 0;
  const allChecked = totalItems > 0 && checkedItems === totalItems;

  const handleCheckAll = () => {
    form.setFieldValue(
      'items',
      form.values.items.map(item => ({ ...item, isChecked: true }))
    );
  };

  return (
    <form id="checklist-submission-form" onSubmit={onSubmit} className={styles.fullFormContainer}>
      {totalItems > 0 && (
        <Progress value={progress} color="green" size="sm" className={styles.progressBar} />
      )}
      {form.values.items.map((item, index) => (
        <div
          className={classnames(styles.optionRow, {
            [styles.optionRowSelected]: form.getInputProps(`items.${index}.isChecked`).value,
          })}
          key={item.checklistItemId}
        >
          <div className={styles.checkboxWrapper}>
            <Checkbox
              className={styles.checkbox}
              classNames={{
                label: styles.checkboxLabel,
                root: styles.checkboxRoot,
                labelWrapper: styles.labelWrapper,
              }}
              {...form.getInputProps(`items.${index}.isChecked`, { type: 'checkbox' })}
              label={checklist?.items.find(i => i.id === item.checklistItemId)?.label}
            />
          </div>
        </div>
      ))}
      {!allChecked && totalItems > 0 && (
        <Button
          variant="transparent"
          leftSection={<IconChecks size={20} />}
          onClick={handleCheckAll}
          className={styles.checkAllButton}
        >
          {t('checklist.form.checkAll', 'Tout valider')}
        </Button>
      )}
      <div className={styles.turboSection}>
        <NumberInput
          label={t('checklist.form.duration', 'Durée (en minutes, optionnel)')}
          placeholder={t('checklist.form.durationPlaceholder', 'ex. 90')}
          min={0}
          max={24 * 60}
          allowDecimal={false}
          {...form.getInputProps('durationMinutes')}
        />
        <Textarea
          label={t('checklist.form.globalComment', 'Note pour la famille (optionnel)')}
          placeholder={t(
            'checklist.form.globalCommentPlaceholder',
            'ex. Tout est OK, juste à remplacer la pile du détecteur'
          )}
          autosize
          minRows={2}
          maxRows={5}
          maxLength={500}
          {...form.getInputProps('globalComment')}
        />
      </div>
      <div className={styles.buttonsContainer}>
        {onCancel && (
          <Button onClick={onCancel} variant="outline" className="btn-medium">
            {t('checklist.form.cancel', 'Annuler')}
          </Button>
        )}
        <Button type="submit" variant="primary">
          {submitButtonLabel}
        </Button>
      </div>
    </form>
  );
};

export default ChecklistSubmissionForm;
